'use client';

import { Button } from '@/components/ui/button';
import { Phone } from 'lucide-react';

export function HelpSectionComponent() {
  return (
    <section className="py-8 bg-white">
      <div className="container mx-auto px-4">
        <div className="max-w-4xl mx-auto bg-[#00B67A] text-white overflow-hidden relative rounded-xl">
          <div className="px-4 py-8 text-center relative z-10">
            <h2 className="text-3xl md:text-4xl font-bold mb-4">Need help?</h2>
            <p className="text-lg md:text-xl max-w-2xl mx-auto mb-8">
              Let one of our advisors help you. It's a no pressure call, we only care about you picking the right
              protection.
            </p>
            <a href="tel:8885550123">
              <Button className="bg-white hover:bg-gray-100 text-[#00B67A] px-8 py-6 text-lg rounded-full" size="lg">
                <Phone className="mr-2 h-5 w-5" />
                Call {clientConfig.NEXT_PUBLIC_WP_SUPPORT_PHONE_NUMBER}
              </Button>
            </a>
          </div>
          <div className="absolute bottom-0 left-0 right-0">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 320" className="w-full">
              <path
                fill="#00A067"
                fillOpacity="0.3"
                d="M0,224L60,213.3C120,203,240,181,360,181.3C480,181,600,203,720,213.3C840,245,960,224,1080,208C1200,192,1320,160,1380,144L1440,128L1440,320L1380,320C1320,320,1200,320,1080,320C960,320,840,320,720,320C600,320,480,320,360,320C240,320,120,320,60,320L0,320Z"
              ></path>
              <path
                fill="#00A067"
                fillOpacity="0.5"
                d="M0,288L60,272C120,256,240,224,360,213.3C480,203,600,213,720,229.3C840,245,960,267,1080,261.3C1200,256,1320,224,1380,208L1440,192L1440,320L1380,320C1320,320,1200,320,1080,320C960,320,840,320,720,320C600,320,480,320,360,320C240,320,120,320,60,320L0,320Z"
              ></path>
            </svg>
          </div>
        </div>
      </div>
    </section>
  );
}
